import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { AdminCompaniesPage } from 'unit-admin/pages';
import { NotFoundPage } from 'unit-error-pages/pages';
import { Urls } from './urls';


export class Routes extends React.Component<RouteComponentProps<{}>> {
  public render(): JSX.Element {
    return (
      <Switch>
        <Route exact={true} path={Urls.companies.path} component={AdminCompaniesPage} />
        <NotFoundPage />;
      </Switch>
    );
  }
}
